import { isResource } from '@medplum/core'
import type { Goal } from '@medplum/fhirtypes'
import { ExtendedResource } from '#src/ExtendedResource.ts'
import { isOfType } from '#src/utils.ts'

export class PatientGoal extends ExtendedResource<Goal> {
  static readonly RESOURCE_TYPE = 'Goal'

  static isInstance(value: unknown): value is Goal {
    return isResource(value) && isOfType(value, 'Goal')
  }

  static build(params: {
    description: string
    subject: Goal['subject']
    note?: string
  }): PatientGoal {
    return new PatientGoal({
      lifecycleStatus: 'proposed',
      subject: params.subject,
      description: { text: params.description },
      note: params.note ? [{ text: params.note }] : undefined,
    })
  }
}
